import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";
import SeleccionarEmpresa from "./Seleccionarempresa";
import NovaEmpresa from "./Novaempresa";
import ModificarEmpresa from "./Modificarempresa";
import EsborrarEmpresa from "./Esborrarempresa";
import ConsultarEmpresa from "./Consultarempresa";
import "./empresa.css";

function Empresa() {
  const [activeTab, setActiveTab] = useState("seleccionar");
  const { onEmpresaSelect } = useOutletContext();
  //console.log("onEmpresaSelect rebut a Empresa.js:", onEmpresaSelect);
  //console.log("Funció onEmpresaSelect definida?", !!onEmpresaSelect); //nou

  const renderActiveTab = () => {
    switch (activeTab) {
      case "seleccionar":
        return <SeleccionarEmpresa onEmpresaSelect={onEmpresaSelect} />;
      case "nova":
        return <NovaEmpresa />;
      case "modificar":
        return <ModificarEmpresa />;
      case "esborrar":
        return <EsborrarEmpresa />;
      case "consultar":
        return <ConsultarEmpresa />;
      default:
        return <SeleccionarEmpresa onEmpresaSelect={onEmpresaSelect} />;
    }
  };

  return (
    <div className="Dashboard-container">
      <div className="Dashboard-tabs">
        <div
          className={`Dashboard-tab ${
            activeTab === "seleccionar" ? "active" : ""
          }`}
          onClick={() => setActiveTab("seleccionar")}
        >
          Seleccionar Empresa
        </div>
        <div
          className={`Dashboard-tab ${activeTab === "nova" ? "active" : ""}`}
          onClick={() => setActiveTab("nova")}
        >
          Nova Empresa
        </div>
        <div
          className={`Dashboard-tab ${
            activeTab === "modificar" ? "active" : ""
          }`}
          onClick={() => setActiveTab("modificar")}
        >
          Modificar Empresa
        </div>
        <div
          className={`Dashboard-tab ${activeTab === "esborrar" ? "active" : ""}`}
          onClick={() => setActiveTab("esborrar")}
        >
          Esborrar Empresa
        </div>
        <div
          className={`Dashboard-tab ${
            activeTab === "consultar" ? "active" : ""
          }`}
          onClick={() => setActiveTab("consultar")}
        >
          Consultar Empresa
        </div>
      </div>
      <div className="Dashboard-content">{renderActiveTab()}</div>
    </div>
  );
}

export default Empresa;

